import React from 'react';
import GenericModal from 'library/components/generic-modal';
import CreateOrganizationForm from './create-organization-form';
import { bool, func } from 'prop-types';

const CreateOrganizationModal = ({ active, toggleActive, reloadOrganizations }) => (
  <GenericModal 
    active={ active } 
    toggleActive={ toggleActive }
    modalHeader="Create Organization"
  >
    <CreateOrganizationForm 
      toggleActive={ toggleActive }
      reloadOrganizations={ reloadOrganizations }
    />
  </GenericModal>
);

CreateOrganizationModal.propTypes = {
  active: bool, 
  toggleActive: func,
  reloadOrganizations: func
};

export default CreateOrganizationModal;